// LeafletNavigationView 拡大縮小全体表示などのチラシ単体のナビゲーションイベントを管理するクラス
class LeafletNavigationView {
  constructor(sceneView) {
    this.sceneView = sceneView
    this.scene = this.sceneView.scene
    this.element = $('.navigation_buttons')
    this.assignEvent()
  }

  render() {
    if (this.scene.magnifiable()) {
      this.element.find('.magnify').addClass('enabled')
    } else {
      this.element.find('.magnify').removeClass('enabled')
    }

    if (this.scene.minifiable()) {
      this.element.find('.minify').addClass('enabled')
    } else {
      this.element.find('.minify').removeClass('enabled')
    }

    if (this.scene.justifiable()) {
      return this.element.find('.justify').addClass('enabled')
    } else {
      return this.element.find('.justify').removeClass('enabled')
    }
  }

  changeLeaflet(leafletObject) {
    return this.element.find('.print').attr({ href: leafletObject.print_url })
  }

  assignEvent() {
    return this.element
      .on('click', '.magnify.enabled', () => {
        return this.scene.magnify()
      })
      .on('click', '.minify.enabled', () => {
        return this.scene.minify()
      })
      .on('click', '.justify.enabled', () => {
        return this.scene.justify()
      })
      .on('dblclick', '.navigation_button', (e) => {
        return e.preventDefault()
      })
  }
}

export default LeafletNavigationView;
